import { getIsMediaHover } from 'src/utils/browser';

interface Props {
	/**
	 * Whether the corresponding element is open.
	 */
	open: boolean;
	/**
	 * Should be the `z-index` of the corresponding element - 1.
	 */
	zIndex: number;
	/**
	 * Should close the corresponding element.
	 */
	onClose: () => void;
}

/**
 * A transparent overlay that catches taps outside of some corresponding element.
 *
 * Useful for popups, tooltips, etc. that on non-hover devices (typically mobile),
 * require the user to tap outside to close, which can trigger elements underneath
 * the tap in the DOM.
 */
export default function TapOverlay({ open, zIndex, onClose }: Props) {
	const isMediaHover = getIsMediaHover();

	if (isMediaHover || !open) {
		return null;
	}

	return (
		<div
			className="fixed inset-0"
			style={{ zIndex }}
			// Without this, the corresponding element may not close within modals.
			onPointerDown={() => setTimeout(onClose, 200)}
			// Prevents any extra "ghost click" from triggering.
			onTouchEnd={(e) => e.preventDefault()}
		/>
	);
}
